// PLEASE REMOVE `LOCAL STORAGE` WHEN YOU CHANGE SETTINGS.
// ----------------------------------------------------------------------

export const defaultSettings = {
  cookiesStatus: "", // '', 'accepted', 'rejected', or 'custom'
  preferences: {
    analytics: true,
    marketing: true,
  },
};